const GtmDataLayer = {

    //event 事件, value 價錢, transaction_id 要保序號, payment_phase 付款階段,
    //item_category2 網投/網要 item_category3 商品類型, item_list_id 產品ID, item_list_name 產品名稱
    policyEvent(event, value, transaction_id, payment_phase
                , item_category2, item_category3
                , item_list_id, item_list_name){
        //建立資料
        const data= {
            event: event
        }

        const ecommerce = {
            currency: 'TWD',
            value: value,
        }

        if(transaction_id){
            ecommerce.transaction_id = transaction_id;
        }
        if(payment_phase){
            ecommerce.payment_phase = payment_phase;
        }

        const items = [
            {
                item_id: 'travel-taiwan',
                item_name: '國內旅平險',
                item_brand: '新安東京海上產物保險',
                item_category : '新保',
                item_list_id : item_list_id,
                item_list_name : item_list_name,
                price : value,
                quantity : 1
            }
        ]

        if(item_category2){
            let itemCategory2Value = '';
            switch (item_category2){
                case "INSURE":
                    itemCategory2Value = '網路投保';
                    break;
                case "APPLY":
                    itemCategory2Value = '網路要保';
                    break;
            }

            items[0].item_category2 = itemCategory2Value;
        }
        if(item_category3){
            let itemCategory3Value = '';
            switch (item_category3) {
                case "I00":
                case "I01":
                case "I05":
                case "I06":
                    itemCategory3Value = '平安福';
                    break;
                case "I03":
                case "I04":
                    itemCategory3Value = '平安御守';
                    break;
            }

            items[0].item_category3 = itemCategory3Value;
        }

        ecommerce.items = items;
        data.ecommerce = ecommerce;
        //推入 dataLayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    },
    memberEvent(event){
        let data = {
            event : event,
            method : '國內旅平險',
        }
        //推入 dataLayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push(data)
    },
    pageViewEvent(){
        let data = {
            event : 'page_view_datalayer',
            pageUrl : window.location.href,
            pageTitle : document.title
        }

        //推入 dataLayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push(data)
    }
}

export default GtmDataLayer;